import { render, staticRenderFns } from "./InputStep.vue?vue&type=template&id=2c0057e8&"
import script from "./InputStep.vue?vue&type=script&lang=js&"
export * from "./InputStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactStepHeader: require('/opt/build/repo/components/contact/StepHeader.vue').default})
